import subject1 from '../assets/img/subject1.jpg';
import subject2 from '../assets/img/subject2.jpg';
import subject3 from '../assets/img/subject3.jpg';
import subject4 from '../assets/img/subject4.jpg';
import subject5 from '../assets/img/subject5.jpg';
import subject6 from '../assets/img/subject6.jpg';
import subject7 from '../assets/img/subject7.jpg';
import subject8 from '../assets/img/subject8.jpg';
import subject9 from '../assets/img/subject9.jpg';
import commingsoon from '../assets/img/commingsoon.webp';


const third = [
    {
        title: "ANALOG ELECTRONIC CIRCUIT",
        description: "AEC",
        imgUrl: subject1,
        link:"https://drive.google.com/drive/folders/1rI8W7T8xplt9l8fZ3gdi9ChDkViVl2J1"
    },
    {
        title: "DIGITAL SYSTEM DESIGN WITH VERILOG",
        description: "DSD",
        imgUrl: subject2,
        link:"https://drive.google.com/drive/folders/1yFmWDvU52zVUYP6Clm3o-KpRE1a_Y3zd"
    },
    {
        title: "SIGNALS AND SYSTEMS",
        description: "SS",
        imgUrl: subject3,
        link:"https://drive.google.com/drive/folders/1TvI2iyH61wTaQTUtEwYkFcUuD_9UGPOY"
    },
    {
        title: "VECTOR CALCULUS, COMPLEX FUNCTIONS AND TRANSFORM TECHNIQUES",
        description: "VCTT",
        imgUrl: subject4,
        link:"https://drive.google.com/drive/folders/1cizYi_Lm42ZYUaw11vx9b1GzUN0i9MAY"
    },
    {
        title: "NETWORK THEORY AND CONTROL SYSTEM",
        description: "NTCS",
        imgUrl: subject5,
        link:"https://drive.google.com/drive/folders/14eE2lCkTLTZCuFNgojPcipBQA4skYnyO"
    },
    {
        title: "PYTHON PROGRAMMING LAB",
        description: "PPL",
        imgUrl: subject6,
        link:"https://drive.google.com/drive/folders/1mJEl-O3d--6krU7QbNawmVza9B_L1tq8"
        
    },
    {
        title: "BALAKE, SAMSKRUTHIKA KANNADA",
        description: "KANNADA",
        imgUrl: subject7,
        link:"https://drive.google.com/drive/folders/1CJY6WZsFCLMTBMmoBli0o_RH_khfpCuG"
        
    },
    {
        title: "ENHANCING SELF COMPETENCE",
        description: "ESA",
        imgUrl: subject8,
        link:"https://drive.google.com/drive/folders/1oAtP80ypS_YS6ByHVSd6LbthLqlC-BEV"
        
    },
    {
        title: "ESSENCE OF INDIAN CULTURE",
        description: "EIC",
        imgUrl: subject9,
        link:"https://drive.google.com/drive/folders/1boPhmkVpl_a2GhfClfX5Y_F7BslydxSC"
    },
];

const fourth = [
    {
        title: "ANALOG ELECTRONIC CIRCUIT",
        description: "AEC",
        imgUrl: subject1,
        link:"https://drive.google.com/drive/folders/1XlXf-rAToII9JeGT6lMofMsQ3yd4alt0"
    },
    {
        title: "COMMUNICATION SYSTEM",
        description: "CS",
        imgUrl: subject5,
        link:"https://drive.google.com/drive/folders/1S3fZWT1FXOlp7FiigWK3w1RvRixR9oG7"
    },
    {
        title: "SIGNAL PROCESING",
        description: "SP",
        imgUrl: subject3,
        link:"https://drive.google.com/drive/folders/1ZVuK3mdaiW1ZNJs5z-LY8Cm2BuQL_Fa2"
    },
    {
        title: "ELECTROMAGNATIC WAVE THEORY",
        description: "EWT",
        imgUrl: subject4,
        link:"https://drive.google.com/drive/folders/1jioqeFMNBCJuSy59gH2o1QFtwgZnnAZy"
    },
    {
        title: "PROBABILITY THEORY AND NUMIRICAL METHODS",
        description: "PTNM",
        imgUrl: subject4,
        link:"https://drive.google.com/drive/folders/1pUxZrTr9VtxlZpybskwT3_lYwvYAdY0W"
    },
    {
        title: "INNOVATIONS AND DESIGN THINKING",
        description: "IDT",
        imgUrl: subject2,
        link:"https://drive.google.com/drive/folders/1ow5rOCg9XHeHzapgRL3Q3pe399XZydF6"
    },
    {
        title: "SYSTEM VERILOG LAB",
        description: "SV LAB",
        imgUrl: subject6,
        link:"https://drive.google.com/drive/folders/1BW7COKJ7c6gx12-XxizmpGFw9LE1S9qr"
        
    },
    {
        title: "UNIVERSAL HUMAN VALUES",
        description: "UHV",
        imgUrl: subject8,
        link:"https://drive.google.com/drive/folders/1fGCnoxb7XA0ROfQPKnCp8tCVyCdYhuAe"
        
    },
];

const fifth = [
    {
        title: "DIGIAL COMMUNICATION",
        description: "DC",
        imgUrl: subject3,
        link:"https://drive.google.com/drive/folders/1K1gnMa8ZrJHENTLQ_Aj8ZNFok5r4kVpm"
    },
    {
        title: "INFORMATION THEORY AND CODING",
        description: "ITC",
        imgUrl: subject2,
        link:"https://drive.google.com/drive/folders/1kA2oz01cPiU4MehYkkgDIj1TarQ70XHp"
    },
    {
        title: "MICROPROCESSOR AND MICROCONTROLLER",
        description: "MPMC",
        imgUrl: subject1,
        link:"https://drive.google.com/drive/folders/19Y-QNMKCUOgD25gl1frEL_KNav-rbkSQ"
    },
    {
        title: "VERY LARGE-SCALE INTEGRATION DESIGN",
        description: "VLSI",
        imgUrl: subject5,
        link:"https://drive.google.com/drive/folders/1-ojPNqPVHJ1CSembxghKV0Ibh64vIfol"
    },
    {
        title: "VERY LARGE-SCALE INTEGRATION DESIGN LAB",
        description: "VLSI LAB",
        imgUrl: subject6,
        link:"https://drive.google.com/drive/folders/1lgRH93TUQjsu98um_88zsxyF8FdHfrM-"
    },
    {
        title: "RESEARCH METHODOLOGY AND INTELLECTUAL PROPERTY RIGHTS",
        description: "RMIP",
        imgUrl: subject9,
        link:"https://drive.google.com/drive/folders/1ExElU6jUSiEQL7xwRan7Nt_REYvupdMr"
        
    },
    {
        title: "EMPLOYABILITY SKILL DEVELOPMENT",
        description: "ESD",
        imgUrl: subject8,
        link:"https://drive.google.com/drive/folders/183PbNpzcidP_J87MaiAYOyVurftQgfx5"
    },
    {
        title: "ENVIRONMENTAL STUDIES",
        description: "EVS",
        imgUrl: subject7,
        link:"https://drive.google.com/drive/folders/1pnZud0m9UtdXTusQiWv9KzNlTzY7wHda"
        
    },
];

const sixth = [
    {
        title: "ANTENNA AND MICROWAVE SYSTEMS",
        description: "AMS",
        imgUrl: subject3,
        link:"https://drive.google.com/drive/folders/1WO87CAAJsOwPxBqvgvAm9gjiOxqOjFyd"
    },
    {
        title: "COMPUTER NETWORKS",
        description: "CN",
        imgUrl: subject2,
        link:"https://drive.google.com/drive/folders/11jhwjEVCEAuxjlt8B_WPQM4UmYHbeZJI"
    },
    {
        title: "OPERATIONS RESEARCH AND PROJECT MANAGEMENT",
        description: "ORPM",
        imgUrl: subject1,
        link:"https://drive.google.com/drive/folders/12Yy_LoMI5aa4AkSzr3u2LJxC9N6agRw0"
    },
    {
        title: "PROFESSIONAL ELECTIVE COURSE 1",
        description: "PSC1",
        imgUrl: subject5,
        link:"https://drive.google.com/drive/folders/19ejQz2jmwoU5DAoKPFqSeQxjuMgc_DIt"
    },
    {
        title: "OPEN ELECTIVE COURSE 1",
        description: "OEC1",
        imgUrl: subject6,
        link:"https://drive.google.com/drive/folders/1W7kFqtTvbyL3dHnfB5XgaWc7R7DpeVQQ"
    },
    {
        title: "COMMUNICATION LAB",
        description: "CL",
        imgUrl: subject8,
        link:"https://drive.google.com/drive/folders/1-1OmtD1zB6a9ECsVjlqgxERTxrAUaD9N"
    }
];

const seventh = [
    {
        title: "coming soon",
        description: "coming soon",
        imgUrl: commingsoon,
        link:"#"
        
    },
]

const eigth = [
    {
        title: "coming soon",
        description: "coming soon",
        imgUrl: commingsoon,
        link:"#"
        
    },
]

export {third,fourth,fifth,sixth,seventh,eigth};
